module.exports = __webpack_public_path__ + "img/image1510.d1071720.jpg";